import type { OrderDietaryRequirement } from "../../../common/jsonRpcTypes";

export function partitionDietaryRequirements(
  requirements: OrderDietaryRequirement[],
  groupNames: ReadonlySet<string>,
): {
  topRequirements: OrderDietaryRequirement[];
  requirementsByName: Map<string, OrderDietaryRequirement[]>;
} {
  const topRequirements: OrderDietaryRequirement[] = [];
  const requirementsByName = new Map<string, OrderDietaryRequirement[]>();

  for (const requirement of requirements) {
    const name = requirement.name;
    if (!name?.trim() || !groupNames.has(name)) {
      topRequirements.push(requirement);
      continue;
    }

    const grouped = requirementsByName.get(name) ?? [];
    grouped.push(requirement);
    requirementsByName.set(name, grouped);
  }

  return { topRequirements, requirementsByName };
}

export function dietaryRequirementKey(requirement: OrderDietaryRequirement): string {
  return `${requirement.name ?? ""}:${requirement.diet_types.join("|")}:${requirement.allergies.join("|")}`;
}
